import { SurveyModel } from "survey-core";
import { ReactElementFactory } from "./element-factory";
var ReactSurveyElementsWrapper = /** @class */ (function () {
    function ReactSurveyElementsWrapper() {
    }
    ReactSurveyElementsWrapper.wrapRow = function (survey, element, row) {
        var componentName = survey.getRowWrapperComponentName(row);
        var componentData = survey.getRowWrapperComponentData(row);
        return ReactElementFactory.Instance.createElement(componentName, {
            element: element,
            row: row,
            componentData: componentData,
        });
    };
    ReactSurveyElementsWrapper.wrapElement = function (survey, element, question) {
        var componentName = survey.getElementWrapperComponentName(question);
        var componentData = survey.getElementWrapperComponentData(question);
        return ReactElementFactory.Instance.createElement(componentName, {
            element: element,
            question: question,
            componentData: componentData,
        });
    };
    ReactSurveyElementsWrapper.wrapQuestionContent = function (survey, element, question) {
        var componentName = survey.getQuestionContentWrapperComponentName(question);
        var componentData = survey.getElementWrapperComponentData(question);
        return ReactElementFactory.Instance.createElement(componentName, {
            element: element,
            question: question,
            componentData: componentData,
        });
    };
    ReactSurveyElementsWrapper.wrapItemValue = function (survey, element, question, item) {
        var componentName = survey.getItemValueWrapperComponentName(item, question);
        var componentData = survey.getItemValueWrapperComponentData(item, question);
        return ReactElementFactory.Instance.createElement(componentName, {
            key: element === null || element === void 0 ? void 0 : element.key,
            element: element,
            question: question,
            item: item,
            componentData: componentData,
        });
    };
    ReactSurveyElementsWrapper.wrapMatrixCell = function (survey, element, cell, reason) {
        if (reason === void 0) { reason = "cell"; }
        var componentName = survey.getElementWrapperComponentName(cell, reason);
        var componentData = survey.getElementWrapperComponentData(cell, reason);
        return ReactElementFactory.Instance.createElement(componentName, {
            element: element,
            cell: cell,
            componentData: componentData,
        });
    };
    return ReactSurveyElementsWrapper;
}());
export { ReactSurveyElementsWrapper };
SurveyModel.platform = "react";
